module.exports = __webpack_public_path__ + "static/media/reasons_bg.099424df.png";